(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 768) return; // mobile only

  const blocks = document.querySelectorAll('.footer__block');

  blocks.forEach(function(block) {
    const title = block.querySelector('.aw-footer-toggle');
    const content = block.querySelector('.aw-footer-collapsible');

    // image/logo blocks and newsletter have no toggle
    if (!title || !content) return;

    title.addEventListener('click', function() {
      const willOpen = !title.classList.contains('aw-open');

      // close others
      blocks.forEach(function(other) {
        if (other !== block) {
          const t = other.querySelector('.aw-footer-toggle');
          const c = other.querySelector('.aw-footer-collapsible');
          if (t) t.classList.remove('aw-open');
          if (c) c.classList.remove('aw-open');
        }
      });

      // toggle this one
      title.classList.toggle('aw-open', willOpen);
      content.classList.toggle('aw-open', willOpen);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
